// Google Ads conversion: Inscription .com
// Balise Google AW-11432059358 chargée via app/[locale]/pixelsInit.tsx
// La stub window.gtag est créée immédiatement, donc l'appel queue dans dataLayer
// jusqu'au chargement du script gtag.js (no-op si bloqué par adblocker).

const SIGNUP_COM_SEND_TO = "AW-11432059358/rziGCLzj0bwcEN7Dncsq";

export function fireGoogleAdsSignupConversion(): void {
  if (typeof window === "undefined") return;
  try {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    if (typeof w.gtag === "function") {
      w.gtag("event", "conversion", { send_to: SIGNUP_COM_SEND_TO });
    }
  } catch {}
}
